import React, { Component } from 'react';
import DatePicker from 'bee-datepicker';
import moment from 'moment';
import { localeLang, locale } from '@platform/api';
import Tooltip from '../Tooltip';
import { getSysFieldid } from '@platform/api';

import 'moment/locale/zh-cn';
import 'moment/locale/zh-tw';
import 'moment/locale/en-au';

require('bee-datepicker/build/DatePicker.css');

if (localeLang === 'simpchn') {
    moment.locale('zh-cn');
} else if (localeLang === 'english') {
    moment.locale('en');
} else if (localeLang === 'tradchn') {
    moment.locale('zh-tw');
} else {
    moment.locale(`${localeLang}`);
}

const { MonthPicker } = DatePicker;

require('./index.less');

class YearPicker extends Component {
    constructor(props) {
        super(props);
        let { defaultValue, value } = this.props;
        this.state = {
            localeLang: 'simpchn',
            hasCloseBtn: !!((defaultValue || value)),
            value: value || '',
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.value && !this.state.hasCloseBtn) {
            this.setState({ hasCloseBtn: true });
        }
        this.setState({ value: nextProps.value });
    }

    componentWillMount() {
        this.setState({ localeLang });
    }

	handleChange = val => {
	    const { onChange, format = ['YYYY-MM'], disabled } = this.props;
	    typeof onChange == 'function' && onChange(!val ? val : val.format(format[0]));
	    if (disabled !== true && !val) {
	        this.setState({ hasCloseBtn: false });
	    }
		
	}

	//添加x按钮，清空输入框的日期
	clearValue = () => {
	    let { disabled } = this.props;
	    if (disabled !== true) { //编辑态的时候点击才清空显示的日期
	        this.setState({
	            hasCloseBtn: false,
	            value: '',
	        });
	        this.handleChange(null);
	    }
	}

	render() {
	    let {
	        // format = ['YYYY-MM', 'YYYY.MM', 'YYYYMM', 'YYYY/MM'],
	        format = 'YYYY-MM',
	        placeholder,
	        tableOpen,
	        fieldid,
	        defaultValue,
	        onChange,
	        disabled,
	        ...others
	    } = this.props;
	    fieldid = getSysFieldid(fieldid);
	    let { hasCloseBtn, value } = this.state;
	    if (tableOpen) {
	        return (
	            <div
	                className={`u-form-control-wrapper nc-month-picker ${this.props.className}`}
	                onClick={e => {
	                    e.stopPropagation();
	                }}
	                fieldid={fieldid || null}
	            >
	                {/* {showStar ? <span className="range-picker-required-tag">*</span> : ''} */}
	                <MonthPicker
	                    className="nc-input"
	                    format={format}
	                    locale={locale}
	                    placeholder={placeholder}
	                    renderIcon={this.props.renderIcon}
	                    value={value ? moment(value) : null}
	                    defaultValue={defaultValue ? moment(defaultValue) : null}
	                    onChange={this.handleChange}
	                    dropdownClassName=" nc-calendar"
	                    {...others}
	                />
	            </div>
	        );
	    } else {
	        return (
	            <div
	                className={`u-form-control-wrapper nc-month-picker ${this.props.className}`}
	                fieldid={fieldid || null}
	            >	
	                <div style={{ position: 'relative' }} className="nc-datepicker-input-wrap">
	                    <MonthPicker
	                        className="nc-input"
	                        format={format}
	                        locale={locale}
	                        placeholder={placeholder}
	                        renderIcon={this.props.renderIcon}
	                        value={value ? moment(value) : null}
	                        defaultValue={defaultValue ? moment(defaultValue) : null}
	                        onChange={this.handleChange}
	                        dropdownClassName=" nc-calendar"
	                        disabled={disabled}
	                        renderError={() => (
	                            <Tooltip
	                                visible={true}
	                                className="datepicker-tooltip"
	                                placement="top"
	                                overlay={'请按如下格式输入有效日期: \'YYYY-MM\'}'}
	                            >
	                                <span style={{ position: 'absolute', left: '125px' }} />
	                            </Tooltip>
	                        )}
	                        {...others}
	                    />
	                    {hasCloseBtn && (
	                        <i
	                            className={"nc-datepicker-del-i iconfont icon-qingkong" + (disabled ? ' icon-hidden' : '')}
	                            onClick={() => {
	                                this.clearValue();
	                            }}
	                        />
	                    )}
	                </div>
	            </div>
	        );
	    }
	}
}

YearPicker.defaultProps = {
    renderIcon: () => {
        return <i className="icon iconfont">&#xe6cd;</i>;
    },
    showClose: false,
};
export default YearPicker;
